export enum accountType {
  UNSELECT = 'unselect',
  COMMON = 'common',
  CUSTOM = 'custom',
  ESCROW = 'escrow',
  ISLAMIC = 'islamic',
}

export const subAccountTypeList = [
  {
    title: 'child.commonAccountType', // 普通子帐户
    desc: 'child.commonAccountTypeTips',
    type: accountType.COMMON,
  },
  {
    title: 'trust subaccount', // 托管子帐户
    desc: 'child.subAccountTypeDesc',
    type: accountType.ESCROW,
  },
  {
    title: 'islamic subaccount', // 伊斯兰子帐户
    desc: 'child.islamicSubAccountTypeDesc',
    type: accountType.ISLAMIC,
    showGuide: () => {
      const search = new URLSearchParams(window.location.search);
      const storage = localStorage.getItem('islamic-guide');
      return search.get('showGuide') === 'islamic' && storage !== '1';
    },
  },
];

export const supportSubAccountTypeList = subAccountTypeList.map(
  ({ type }) => type,
);

export enum subAccountPageSearchParams {
  SHOW_CREATE_SUB_ACCOUNT_MODAL = 'createSubAccount',
  SHOW_SELECT_ACCOUNT_MODAL_AND_GUIDE = 'showGuide',
}
